import React__default from 'react';
import PropTypes from 'prop-types';
import { brands } from '../../tools/constants.js';

var propTypes = {
  /** Brand identifier for the product. Used for brand-specific styling */
  children: PropTypes.node.isRequired,
  /** The product name text or content to display */
  brand: PropTypes.oneOf(brands),
  /** Visual size of the product name. Use `l` for large */
  size: PropTypes.oneOf(['', 'l'])
};
function ProductName(_ref) {
  var brand = _ref.brand,
    children = _ref.children,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "product-name product-name-font-size",
    "data-brand": brand,
    "data-size": size
  }, children);
}
ProductName.propTypes = propTypes;

export { ProductName as default };
//# sourceMappingURL=ProductName.js.map
